<template>
	<section>
								
		<h3>Finalizing</h3>

		<template v-if="!hidePartialPayments">
			<field label="Partial Payment?"
				col-class="col-lg-3 col-sm-4"
				:params="{type:'boolean'}"
				v-model="partialPayment"
				v-on:change="partialPaymentToggleChange">
			</field>

			<field v-if="partialPayment"
				class="mb-2"
				label="Amount Due"
				col-class="col-lg-3 col-sm-4"
				:params="{type:'number',max:this.invoiceDetails.grand_total,step:0.01,max:balanceOwing}" 
				:invalid="$store.errorList.amount_due"
				v-model="invoiceDetailsLocal.amount_due"
				v-on:change="valuesChanged">
			</field>
		</template>

		<field v-for="tax in salesTaxes"
			:label="'Charge '+tax.label"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'boolean'}"
			v-model="appliedTaxes[tax.label]">
		</field>

		<field v-if="qboIsActive"
			label="Exchange Rate"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'number', step:'0.0001'}"
			v-model="invoiceDetailsLocal.exchange_rate"
			v-on:change="valuesChanged">
			<p class="text-muted">Set the exchange rate only if you're issuing the invoice in a foreign currency (QBO requires this)</p>
		</field>
		<div v-if="showUntaxableCreditWarning" class="alert alert-warning">
			The invoice untaxable amount is a credit. Quickbooks does not support credit line items on invoices, so this credit will be omitted from the Quickbooks version of the invoice.
		</div>

		<field 
			class="mb-2"
			:label="typeName+' Date'"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'date'}" 
			:invalid="$store.errorList.issue_date"
			v-model="invoiceDetailsLocal.issue_date"
			v-on:change="valuesChanged">
		</field>

		<field v-if="isQuote || isProjectChangeQuote"
			class="mb-2"
			label="Followup Date"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'date'}" 
			:invalid="$store.errorList.quote_followup_date"
			v-model="invoiceDetailsLocal.quote_followup_date"
			v-on:change="valuesChanged">
		</field>

		<field v-if="isProjectChangeQuote"
			class="mb-2"
			label="Expires in (days)"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'number'}" 
			:invalid="$store.errorList.expires_in_days"
			v-model="invoiceDetailsLocal.expires_in_days"
			v-on:change="valuesChanged">
		</field>

		<!--
			<field 
				class="mb-2"
				label="ATTN"
				col-class="col-lg-3 col-sm-4"
				:params="{
				  type:'text',
				  placeholder:'ahhh'
			  }"
				v-model="invoiceDetailsLocal.attn"
				v-on:change="valuesChanged">
			</field>
			-->

		<form-group class="mb-2"
			label="ATTN"
			col-class="col-lg-3 col-sm-4">

			<div class="d-flex">
				<field v-if="manualAttn"
					class="flex-grow-1"
					v-model="invoiceDetailsLocal.attn"
					v-on:change="valuesChanged">
				</field>
				<field v-else
					class="flex-grow-1"
					:params="{type:'select',options:attnOptions}"
					v-model="invoiceDetailsLocal.attn"
					v-on:change="attnSelected">
				</field>
				<div>
					<button class="btn btn-light btn-attached" v-on:click="manualAttn = !manualAttn">
						<i class="fa" :class="{
								'fa-pencil-alt': !manualAttn,
								'fa-caret-down': manualAttn
							}">		
						</i>
					</button>
				</div>
			</div>

		</form-group>

		<field 
			class="mb-2"
			label="Payment Terms"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'select',options:paymentTermsOptions}" 
			:invalid="$store.errorList.payment_terms"
			v-model="invoiceDetailsLocal.payment_terms"
			v-on:change="valuesChanged">
		</field>

		<field 
			class="mb-2"
			label="Notes to Recipient"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'textarea'}" 
			v-model="invoiceDetailsLocal.customer_notes"
			v-on:change="valuesChanged">
			<div class="text-muted">Appears on the {{typeName}} as a "Customer Notes" section</div>
		</field>

		<field 
			class="mb-2"
			label="Bottom Text"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'richtext'}" 
			v-model="invoiceDetailsLocal.bottom_text"
			v-on:input="valuesChanged">
			<div class="text-muted">Appears as fine print at the bottom of the {{typeName}}</div>
		</field>

		<div v-if="minRateWarningText" class="alert alert-danger" v-html="stripInlineEventHandlers(minRateWarningText)"></div>


		<!--<field v-if="typeName == 'Quote'"
			label="Summarized quote"
			col-class="col-lg-3 col-sm-4"
			:params="{type:'boolean'}"
			v-model="summaryQuote">
		</field>-->

	
	</section>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

import ServiceMixins from "@/mixins/ServiceMixins.js"
import ReportsMixins from "@/mixins/ReportsMixins.js"
import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import ContactMixins from "@/mixins/ContactMixins.js"

export default {
	name: "InvoiceFinalizingSection",
	components: {
		Field,
		FormGroup
	},
	mixins: [ServiceMixins, ReportsMixins, InvoiceMixins, ContactMixins],
	props: ["invoiceDetails", "typeName", "hidePartialPayments","isProjectChangeQuote"],
	data() {
		return {
			invoiceDetailsLocal: null,
			service: {},
			customer: {},
			collectiveAgreements: [],
			summaryQuote: false,
			partialPayment: false,
			appliedTaxes: [],
			attnOptions: [],
			manualAttn: false,
		}
	},
	watch: {
		invoiceDetails() {
			this.setInvoiceDetailsLocal()
		},
		'invoiceDetails.payment_terms'() {
			if (!this.invoiceDetailsLocal)
				return
			if (this.invoiceDetailsLocal.payment_terms == null || this.invoiceDetailsLocal.payment_terms === '')
				this.invoiceDetailsLocal.payment_terms = this.invoiceDetails.payment_terms
		},
		'invoiceDetailsLocal.issue_date'() {
			if (!this.invoiceDetails)
				return
			if (this.invoiceDetailsLocal.issue_date == this.invoiceDetails.issue_date)
				return

			this.setDetails()
		},
		appliedTaxes: {
			handler(newVal) {
				let appliedSalesTaxObj = {}
				let companySalesTax = {}

				try {
					companySalesTax = JSON.parse(this.$store.company.CompanySetting.taxes_json)
				} catch (e) {}

				for (const key in newVal) {
					if (newVal[key] && companySalesTax[key])
						appliedSalesTaxObj[key] = companySalesTax[key]
				}

				this.invoiceDetailsLocal.applied_sales_tax_json = JSON.stringify(appliedSalesTaxObj)

				this.$emit("salesTaxToggle", this.invoiceDetailsLocal)
			},
			deep: true
		}
	},
	computed: {
		minRateWarningText() {

			if (!('pretax_total' in this.invoiceDetailsLocal && this.invoiceDetailsLocal.pretax_total))
				return false

			let minRate = 0
			let prefix = ""


			if ('CompanySetting' in this.$store.company && this.$store.company.CompanySetting &&
				'job_defaults_json' in this.$store.company.CompanySetting && this.$store.company.CompanySetting.job_defaults_json)
			{
				try {
					const settings = JSON.parse(this.$store.company.CompanySetting.job_defaults_json)
					if ('min_rate' in settings) { // min_rate might be 0
						minRate = parseFloat(settings.min_rate)
						prefix = "Your company"
					}
				} catch {}
			}

			if (this.invoiceDetailsLocal &&
				'Service' in this.invoiceDetailsLocal && this.invoiceDetailsLocal.Service &&
				'Customer' in this.invoiceDetailsLocal.Service && this.invoiceDetailsLocal.Service.Customer &&
				'settings_json' in this.invoiceDetailsLocal.Service.Customer && this.invoiceDetailsLocal.Service.Customer.settings_json)
			{
				try {
					const settings = JSON.parse(this.invoiceDetailsLocal.Service.Customer.settings_json)
					if ('min_rate' in settings) { // min_rate might be 0
						minRate = parseFloat(settings.min_rate)
						prefix = "This customer"
					}
				} catch {}
			}

			if (minRate > this.invoiceDetailsLocal.pretax_total && !this.isQuote) {
				const difference = (minRate - this.invoiceDetailsLocal.pretax_total).toCurrency()
				return prefix + " has a minimum flat rate charge of $" + minRate.toCurrency() + ". This invoice's pretax total is currently $" + difference + " below the minimum flat rate charge."
			}

			return false
		},
		balanceOwing() {
			let vm = this

			return +this.invoiceDetailsLocal.grand_total - +this.invoiceDetailsLocal.amount_paid
		},
		showUntaxableCreditWarning() {
			if (!this.qboIsActive || !this.invoiceDetailsLocal)
				return false

			return +this.invoiceDetailsLocal.untaxed_total < 0
		}
	},
	methods: {
		setInvoiceDetailsLocal() {

			let vm = this
	  		this.invoiceDetailsLocal = JSON.parse(JSON.stringify(this.invoiceDetails))

			if (!this.invoiceDetails.expires_in_days || this.invoiceDetails.expires_in_days == 0)
				this.invoiceDetails.expires_in_days = this.$store.company.CompanySetting.quote_expiry_days

			let attnValue = this.attnOptions.find(opt => opt.value == this.invoiceDetailsLocal.attn)
			if (attnValue) {
				this.manualAttn = false
				this.invoiceDetailsLocal.attn =  attnValue.text
			}
			else
				this.manualAttn = true

			if (!vm.partialPayment && vm.invoiceDetailsLocal.amount_due == 0)
				vm.invoiceDetailsLocal.amount_due = vm.invoiceDetails.grand_total

			if (!vm.hidePartialPayments && vm.invoiceDetails.amount_due > 0 && vm.invoiceDetails.amount_due != vm.invoiceDetails.grand_total)
				vm.partialPayment = true

			if (localStorage.getItem("togglePartialPayment") == 'true') {
				localStorage.removeItem("togglePartialPayment")
				vm.partialPayment = true
			}
	  	},
		partialPaymentToggleChange(value) {
		  if (!value)
			this.invoiceDetailsLocal.amount_due = this.invoiceDetailsLocal.grand_total

		  this.valuesChanged()
		},
		attnSelected(id) {
			this.manualAttn = true

			this.$nextTick(() => {
				let attnValue = this.attnOptions.find(opt => opt.value == id)

				if (attnValue) 
					this.invoiceDetailsLocal.attn =  attnValue.text

				this.setDetails()
			})
		},
		setDetails() {
			if (!this.invoiceDetailsLocal)
				return

			let localTermsUnset = this.invoiceDetailsLocal.payment_terms == null || this.invoiceDetailsLocal.payment_terms === ''
			let parentTermsUnset = true
			if (this.invoiceDetails)
				parentTermsUnset = this.invoiceDetails.payment_terms == null || this.invoiceDetails.payment_terms === ''

			if (localTermsUnset && !parentTermsUnset)
				this.invoiceDetailsLocal.payment_terms = this.invoiceDetails.payment_terms

			this.$emit("detailsChange", this.invoiceDetailsLocal)
		},
		valuesChanged(value) {
		  this.$nextTick(() => {
			if (!this.partialPayment)
			  this.invoiceDetailsLocal.amount_due = 0

			this.setDetails()
		  })
		},
		setSalesTax() {
			let vm = this
			this.appliedTaxes = {}

			let appliedSalesTaxObj = {}
			try {
				appliedSalesTaxObj = JSON.parse(this.invoiceDetails.applied_sales_tax_json)
			}
			catch (e) {}

			this.salesTaxes.forEach(tax => {
				const label = tax.label
				const value = (label in appliedSalesTaxObj) ? 1 : 0
				// Ensure reactivity using Vue.set
				vm.$set(vm.appliedTaxes, label, value)
			})
		},
		salesTaxToggle(taxKey) {
			let vm = this

			this.$nextTick(() => {

				let appliedSalesTaxObj = {}
				let companySalesTax = {}
				try {
					appliedSalesTaxObj = JSON.parse(vm.invoiceDetails.applied_sales_tax_json)
				}
				catch (e) {}
				try {
					companySalesTax = JSON.parse(vm.$store.company.CompanySetting.taxes_json)
				}
				catch (e) {}

				if (!vm.appliedTaxes[taxKey])
					delete appliedSalesTaxObj[taxKey]
				else if (taxKey in companySalesTax)
					appliedSalesTaxObj[taxKey] = companySalesTax[taxKey]

				vm.invoiceDetailsLocal.applied_sales_tax_json = JSON.stringify(appliedSalesTaxObj)

				vm.$emit("salesTaxToggle", vm.invoiceDetailsLocal)
			})
		},
		
		fetchCustomer() {
			let vm = this
			let params = {
				fields: ["name","SubContacts"],
				include: [
					{
						model: "Contact",
						fields: ["name"]
					}
				]
			}

			let customerId 
			if (vm.invoiceDetailsLocal.customer_id > 0)
				customerId = vm.invoiceDetailsLocal.customer_id
			else if ("Service"  in vm.invoiceDetailsLocal && vm.invoiceDetailsLocal.Service)
				customerId = vm.invoiceDetailsLocal.Service.customer_id
			else if ("Job" in vm.invoiceDetailsLocal && vm.invoiceDetailsLocal.Job)
				customerId = vm.invoiceDetailsLocal.Job.customer_id
			else if ("customer_id" in vm.$store.project)
				customerId = vm.$store.project.customer_id

			vm.getJSON("Contact/find/" + customerId, params).then(response => {
				if (response.success) {
					vm.customer = response.data

					let options = [
						vm.customer,
						...vm.customer.SubContacts
					]

					vm.attnOptions = vm.optionify(options,"name")

					let attnValue = vm.attnOptions.find(opt => opt.value == vm.invoiceDetailsLocal.attn)
					if (attnValue)
						vm.invoiceDetailsLocal.attn =  attnValue.text
				}
			})
		},
	},
	created() {
		this.setInvoiceDetailsLocal()
		this.setSalesTax()
		this.fetchCustomer()
	}
}
</script>

<style type="text/css" scoped>
	
	.financial-summary {
		margin-bottom: 10px;
	}

	.financial-summary .card {
		margin-right: 5px;
	}
</style>